import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./CHome.scss";
import CHeader from "../Header/CHeader";
import { Routes, Route } from 'react-router-dom';
import Landing from "./landing/Landing";
import UniversalFooter from "../Footer/CFooter";
import Agentic from "../Agentic/Agentic";
import CRM2002 from "./CRM001/CRM2002";
import AC24100 from "./AC24100/AC24100";
import EMC45002 from "./EMC45002/EMC45002";
import SG3002 from "./SG3002/SG3002";
import HMS42003 from "./HMS42003/HMS42003";
import EDU568 from "./EDU5128/EDU568";
import IND5208372 from "./IND520837/IND5208372";
import CH20041 from "./CH2008/CH20041";
import AB65001 from "./AB66002/AB65001";
import CO93110 from "./CO92522/CO93110";
import Register from "../../../authentication/Register/Register";

const BUBBLE_SIZE = 64;
const CHAT_WIDTH = 380;
const CHAT_HEIGHT = 580;
const EDGE_MARGIN = 16;
const STORAGE_KEY = "cilpron-chat-bubble-pos";
const WIDGET_ORIGIN = "https://wchannel.cilpron.com";

interface Offset {
  right: number;
  bottom: number;
}

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

const ChatWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [offset, setOffset] = useState<Offset>(() => {
    if (typeof window === "undefined") return { right: 24, bottom: 24 };
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved);
    } catch {
      /* ignore — localStorage unavailable (private mode, etc.) */
    }
    return { right: 24, bottom: 24 };
  });

  const draggingRef = useRef(false);
  const movedRef = useRef(false);
  const dragStartRef = useRef({ pointerX: 0, pointerY: 0, originRight: 0, originBottom: 0 });
  const iframeRef = useRef<HTMLIFrameElement>(null);

  function handlePointerDown(e: React.PointerEvent) {
    draggingRef.current = true;
    movedRef.current = false;
    dragStartRef.current = {
      pointerX: e.clientX,
      pointerY: e.clientY,
      originRight: offset.right,
      originBottom: offset.bottom,
    };
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
  }

  function handlePointerMove(e: React.PointerEvent) {
    if (!draggingRef.current) return;
    const dx = e.clientX - dragStartRef.current.pointerX;
    const dy = e.clientY - dragStartRef.current.pointerY;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) movedRef.current = true;

    const nextRight = clamp(
      dragStartRef.current.originRight - dx,
      EDGE_MARGIN,
      window.innerWidth - BUBBLE_SIZE - EDGE_MARGIN
    );
    const nextBottom = clamp(
      dragStartRef.current.originBottom - dy,
      EDGE_MARGIN,
      window.innerHeight - BUBBLE_SIZE - EDGE_MARGIN
    );
    setOffset({ right: nextRight, bottom: nextBottom });
  }

  function handlePointerUp() {
    draggingRef.current = false;

    setOffset((prev) => {
      const bubbleLeft = window.innerWidth - prev.right - BUBBLE_SIZE;
      const snappedRight =
        bubbleLeft + BUBBLE_SIZE / 2 < window.innerWidth / 2
          ? window.innerWidth - BUBBLE_SIZE - EDGE_MARGIN
          : EDGE_MARGIN;
      const next = { right: snappedRight, bottom: prev.bottom };
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        /* ignore */
      }
      return next;
    });

    if (!movedRef.current) {
      setIsOpen((v) => !v);
    }
  }

  function handleIframeLoad() {
    iframeRef.current?.contentWindow?.postMessage({ type: "CILPRON_OPEN" }, WIDGET_ORIGIN);
  }

  useEffect(() => {
    function handleMessage(e: MessageEvent) {
      if (e.origin !== WIDGET_ORIGIN) return;
      if (e.data?.type === "CILPRON_CLOSE") setIsOpen(false);
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const panelBottom = offset.bottom + BUBBLE_SIZE + 8;
  const flipUp = typeof window !== "undefined" && panelBottom + CHAT_HEIGHT > window.innerHeight - EDGE_MARGIN;

  return ReactDOM.createPortal(
    // Chat widget disabled — commented out, not deleted, so it can be
    // switched back on later without rebuilding this component.
    // <>
    //   {isOpen && (
    //     <iframe
    //       ref={iframeRef}
    //       onLoad={handleIframeLoad}
    //       title="Cilpron Chat We Channels"
    //       src="https://wchannel.cilpron.com/?businessId=fdf51fad-9513-4a69-9863-d2bf2e8127f7&agent=Anna&avatar=https://wchannel.cilpron.com/png/Anna.png&apiUrl=https://bridge.cilpron.com&staffPhone=2348122221040"
    //       style={{
    //         position: "fixed",
    //         right: offset.right,
    //         bottom: flipUp ? EDGE_MARGIN : panelBottom,
    //         width: CHAT_WIDTH,
    //         height: CHAT_HEIGHT,
    //         border: "none",
    //         borderRadius: 16,
    //         boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
    //         zIndex: 2147483647,
    //         background: "transparent",
    //       }}
    //     />
    //   )}

    //   <div
    //     onPointerDown={handlePointerDown}
    //     onPointerMove={handlePointerMove}
    //     onPointerUp={handlePointerUp}
    //     style={{
    //       position: "fixed",
    //       right: offset.right,
    //       bottom: offset.bottom,
    //       width: BUBBLE_SIZE,
    //       height: BUBBLE_SIZE,
    //       borderRadius: "50%",
    //       background: "#075e54",
    //       boxShadow: "0 4px 14px rgba(0,0,0,0.3)",
    //       zIndex: 2147483647,
    //       cursor: "grab",
    //       touchAction: "none",
    //       userSelect: "none",
    //     }}
    //   >
    //     <img
    //       src="https://wchannel.cilpron.com/png/Anna.png"
    //       alt="Chat with Anna"
    //       style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", pointerEvents: "none" }}
    //       draggable={false}
    //     />
    //   </div>
    // </>,
    null,
    document.body
  );
};

const CHome: React.FC = () => {
  return (
    <>
      <CHeader />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/Artificial-Intelligence" element={<Agentic />} />
        <Route path="/crm" element={<CRM2002 />} />
        <Route path="/accounting" element={<AC24100 />} />
        <Route path="/email-&-calendars" element={<EMC45002 />} />
        <Route path="/swiftgrid-email-api" element={<SG3002 />} />
        <Route path="/hospitality-&-pms" element={<HMS42003 />} />
        <Route path="/academic-portals" element={<EDU568 />} />
        <Route path="/Industries" element={<IND5208372 />} />
        <Route path="/channels" element={<CH20041 />} />
        <Route path="/About" element={<AB65001 />} />
        <Route path="/contact" element={<CO93110 />} />
        <Route path="auth/signup" element={<Register />} />
      </Routes>
      <UniversalFooter />
      <ChatWidget />
    </>
  );
};

export default CHome;